// On-site widget entry
import { WidgetService } from "@/services/widget.service";
// After WidgetService, which initializes i18n before any UI module loads.
import { WidgetContainer } from "@/components/widget-container";

let widgetInstance: WidgetService | null = null;

async function initialize(): Promise<void> {
  if (widgetInstance || typeof document === "undefined") return;
  widgetInstance = new WidgetService({
    variant: "on-site",
    rootComponent: WidgetContainer,
  });
  await widgetInstance.initialize();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initialize);
} else {
  initialize();
}
